<template>
  <div v-if="questionBlock" :key="$route.path">
    <QuestionBlock :key="$route.path" :block-data="questionBlock" />
  </div>
  <div v-else>
    <g-title>Ingen Fråga!</g-title>
  </div>
</template>

<script>
import QuestionBlock from '@/components/QuestionBlock';

export default {
  components: {
    QuestionBlock
  },
  data() {
    return {
      routerParamId: parseInt(this.$route.params.id),
      questionBlock: false
    };
  },
  watch: {
    $route(to, from) {
      this.routerParamId = parseInt(to.params.id);
      this.questionBlock = false;
      this.loadQuestionBlocks();
    }
  },
  beforeMount: function() {
    this.loadQuestionBlocks();
  },
  methods: {
    loadQuestionBlocks() {
      // A fetch http request is used here instead of a GraphQL query,
      // due to the fact that Vue-Apollo does not support Union Types in a nice and simple way.
      // Using Union types with Vue-Apollo 3.0.0 would only create more overhead and more configuration is required.
      // Also, in this context every bit of information is required which means that writing a GraphQL query would be unnecessary work.

      const baseUrl = process.env.VUE_APP_BASE_URL || 'http://localhost:5000';

      fetch(baseUrl + '/question-blocks/' + this.routerParamId)
        .then(res => {
          // Checks if the status code is not 200, if true an error will be thrown
          if (res.status !== 200) throw new Error('Request Error');

          return res.json();
        })
        .then(data => {
          this.questionBlock = data;
        })
        .catch(err => {
          // TODO: Handle error
        });
    }
  }
};
</script>

<style scoped></style>
